import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/atlante';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-ivory px-4 py-5 sm:py-7" data-id="element-41" data-mp="1hdupklvgf9bb">
      <div className="mx-auto max-w-3xl" data-id="element-42" data-mp="1cf9m8dkwo9in">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-2xl" data-id="element-43" data-mp="1cgb5v6fzm4bz">
          DOMANDE FREQUENTI
        </h2>

        <div className="mt-3 space-y-1.5" data-id="element-44" data-mp="2535qc3ct13pg">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-lg border border-navy/15 bg-white shadow-sm" data-id="element-45" data-mp="2031amfjq0d0a" data-mpi={i}>
                <h3 data-id="element-46" data-mp="oovz91h6h0ux">
                  <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition-colors duration-150 hover:bg-gold/10" data-id="element-47" data-mp="op5ub3h2xy7h">
                    <span className="font-sans text-[13.5px] font-bold normal-case tracking-normal text-navy sm:text-[15px]" data-id="element-48" data-mp="1pmbaqu62gvfs">
                      {faq.q}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-soft ${open ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-49" data-mp="1fnc8puft3y1r" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="s0vz0nbz6mq0">
                  {open && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-51" data-mp="wyxg52pucbyu">
                      <p className="px-3 pb-2.5 text-[13px] font-medium leading-snug text-slate2" data-id="element-52" data-mp="2kw6mpz5t5m7g">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}